// extracted by mini-css-extract-plugin
export default {"titleBig":"TitleLogin_titleBig__EdCku"};